import HeaderPaneStore from './schema/HeaderPaneStore';
import { createStore } from 'satcheljs';

export const defaultHeaderPaneStore: HeaderPaneStore = {
    dogfoodFlights: [],
    microsoftFlights: [],
    wwFlights: [],
    selectedFlightConfig: 'DEFAULT',
};

const initialStore = { ...defaultHeaderPaneStore };
export const getStore = createStore<HeaderPaneStore>('headerPaneStore', initialStore);

const store = getStore();
export default store;
